export default __webpack_public_path__ + "static/media/esf.3b198b7b.png";